export default class Wall {
    constructor(game, wallStartPosition, gapYStart, velikostGap, color) {
        this.game = game
        this.width = 50
        this.height = 15
        this.color = color

        this.gap = velikostGap
        this.gapYStart = game.height * (gapYStart / 100) //procenta z vysky hraci plochy
        this.gapYEnd = this.gapYStart + this.gap

        this.x = wallStartPosition
        this.readyToDestroy = false
    }
    // eslint-disable-next-line no-unused-vars
    update(deltaTime) {
        this.x -= this.game.gameSpeed * deltaTime
        if(this.x + this.width < 0) {
            this.readyToDestroy = true
        }
    }
    draw(context) {
        context.globalAlpha = 1
        context.fillStyle = this.color;
        //context.fillRect(this.x, 0, this.width, this.gapYStart + 0.5)
        //context.fillRect(this.x, this.gapYEnd - 0.5, this.width, this.game.height)

        //ontext.beginPath();

        //ontext.moveTo(this.x, this.gapYStart);
        //ontext.lineTo(this.x + this.width, this.gapYStart + this.height);
        //ontext.lineTo(this.x + this.width, this.gapYStart);
        //ontext.closePath();
        
        //ontext.fill();


        context.beginPath();

        context.moveTo(this.x, 0);
        context.lineTo(this.x, this.gapYStart);
        context.lineTo(this.x + this.width, this.gapYStart + this.height);
        context.lineTo(this.x + this.width, this.gapYStart);
        context.lineTo(this.x + this.width, 0);
        context.closePath();

        context.fill();

        context.beginPath();

        context.moveTo(this.x, this.game.height);
        context.lineTo(this.x, this.gapYEnd);
        context.lineTo(this.x + this.width, this.gapYEnd - this.height);
        context.lineTo(this.x + this.width, this.gapYEnd);
        context.lineTo(this.x + this.width, this.game.height);
        context.closePath();

        context.fill();

    }
}